export const MFCActiveIcon = ({ size, className }) => {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 40 40"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
		>
			<rect width="40" height="40" rx="20" fill="#DDE3EE" />
			<g clipPath="url(#clip0_776_19108)">
				<path
					d="M10.9793 17.3368L12.3478 25L18.9805 17.3585L19.0117 19.7794H19.9858L19.9489 15L13.0012 22.9939L11.5589 15.0244L5 24.4768H6.00814L10.9793 17.3368Z"
					fill="#111111"
				/>
				<path
					d="M21.3537 19.7855H26.0624V19.0237H21.3537V15.9739H26.0624V15.2122H20.4016V24.4951H21.3537V19.7855Z"
					fill="#111111"
				/>
				<path
					d="M34.3572 23.8159L35 23.3774L34.6999 22.6902C34.2544 22.9864 33.8791 23.206 33.5825 23.3442C33.0093 23.6045 32.3261 23.7353 31.5506 23.7353C30.307 23.7353 29.2726 23.3571 28.4759 22.6109C27.687 21.8728 27.2882 20.9091 27.2882 19.7461C27.2882 18.5831 27.6926 17.6153 28.4893 16.8705C29.2861 16.1229 30.3169 15.7448 31.5506 15.7448H31.5989C31.6209 15.7454 31.6429 15.7468 31.6656 15.7475L31.3399 15.002C29.9515 15.0433 28.7923 15.4886 27.8941 16.3317C26.9569 17.2087 26.4823 18.3574 26.4823 19.7461C26.4823 21.1348 26.9612 22.289 27.9062 23.1741C28.8412 24.0511 30.0679 24.495 31.5506 24.495C31.6776 24.495 31.7997 24.493 31.9196 24.4889C32.038 24.4828 32.148 24.4767 32.2487 24.4686C33.1285 24.3913 33.8386 24.1724 34.3572 23.8159Z"
					fill="#111111"
				/>
			</g>
			<defs>
				<clipPath id="clip0_776_19108">
					<rect width="30" height="10" fill="white" transform="translate(5 15)" />
				</clipPath>
			</defs>
		</svg>
	)
}
